import React, { useState, useEffect }  from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTestimonies } from './hooks/useTestimonies';
import { formatDate, formatTime } from './utils/dateUtils';

function TestimoniesPage({user, accessToken}) {
    const { getTestimonies, updateTestimonyStatus } = useTestimonies();
    const [testimonies, setTestimonies] = useState([]);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        (async() => {
            setLoading(true);
            try {
                console.log('getting testimonies');
                const testimonies = await getTestimonies(accessToken);
                setTestimonies(testimonies);
            }
            catch(error) {
                console.log(error);
            }
            finally {
                setLoading(false);
            }
        })()
    }, []);

    const getTimestampText = (timestamp) => {
        return `${formatDate(timestamp)} ${formatTime(timestamp)}`;
    }

    const getStatus = (status) => {
        return status === 'PendingApproval' ? 'Pending Approval' : status;
    }

    const approve = async (id) => {
        const updatedTestimony = await updateTestimonyStatus(accessToken, id, 'Active');
        if(updatedTestimony) {
            setTestimonies(testimonies.map(testimony => {
                if(testimony.id === id) {
                    return updatedTestimony;
                }
                else {
                    return testimony;
                }
            }));
        }
    }

    return (
        <div>
            <h5 style={{textAlign: 'left', marginLeft: '25px', marginBottom: '25px'}}>Testimonies:</h5>
            {
                testimonies.length ?  
                    <Table striped bordered hover size="sm" style={{width: '97%', margin: '0 auto'}}>
                        <thead>
                            <tr>
                                <th>Created Date</th>
                                <th>Name</th>
                                <th>Text</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            testimonies.map(testimony => 
                                <tr key={testimony.id}>
                                    <td style={{textAlign: 'left'}}>{getTimestampText(testimony.createdDate)}</td>
                                    <td>{testimony.name}</td>
                                    <td style={{textAlign: 'left'}}>{testimony.text}</td>
                                    <td>{getStatus(testimony.status)}</td>
                                    <td>
                                        {
                                            testimony.status === 'PendingApproval' && <button onClick={() => approve(testimony.id)}>Approve</button>
                                        }
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </Table>
                : 
                loading ? 'Loading...' : 'There are currently no testimonies'
            }
        </div>
    );
}

export default TestimoniesPage;